import { useEffect, useState } from 'react'

import Navbar from '../../components/navbar/navbar'

import IntegracoesService from '../../services/database/IntegracoesService'

import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'
import { CustomSpinner } from '../../components/CustomSpinner'
import { Table } from 'react-bootstrap'
import { IconButton } from '../../components/IconButton'
import { PencilFill, TrashFill } from 'react-bootstrap-icons'
import { ModalEditar } from './ModalEditar'

export function Integracoes() {
  const [integrations, setIntegrations] = useState([])
  const [isIntegrationsLoading, setIsIntegrationsLoading] = useState(true)
  const [selectedIntegration, setSelectedIntegration] = useState(null)

  const [isModalEditarOpen, setIsModalEditarOpen] = useState(false)

  async function loadIntegrations() {
    try {
      setIsIntegrationsLoading(true)
      const data = await IntegracoesService.getAll()

      setIntegrations(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível listar as integrações!')
    } finally {
      setIsIntegrationsLoading(false)
    }
  }

  useEffect(() => {
    loadIntegrations()
  }, [])

  return (
    <>
      <Navbar />

      <div className="mt-page">
        <h1>Integrações</h1>

        {isIntegrationsLoading ? (
          <CustomSpinner />
        ) : (
          <>
            <Table>
              <thead>
                <tr>
                  <th>ID Marketplace</th>
                  <th>Token</th>
                  <th>Plataforma</th>
                  <th>Apelido</th>
                  <th>CNPJ</th>
                  <th>Ações</th>
                </tr>
              </thead>

              <tbody>
                {integrations.map((integration) => (
                  <tr>
                    <td>{integration.id_conta}</td>
                    <td>{integration.token}</td>
                    <td>{integration.plataforma}</td>
                    <td>{integration.id_conta}</td>
                    <td>{integration.emp_cnpj}</td>
                    <td
                      style={{
                        display: 'flex',
                        gap: 5,
                      }}
                    >
                      <IconButton
                        color="#f39c12"
                        onClick={() => {
                          setSelectedIntegration(integration)
                          setIsModalEditarOpen(true)
                        }}
                      >
                        <PencilFill />
                      </IconButton>

                      <IconButton color="#dd4b39">
                        <TrashFill />
                      </IconButton>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </div>

      <ModalEditar
        isOpen={isModalEditarOpen}
        onClose={() => {
          setSelectedIntegration(null)
          setIsModalEditarOpen(false)
        }}
        integration={selectedIntegration}
      />
    </>
  )
}
